import React, { Component } from "react";
import styles from "./Modal.scss";
import classnames from "classnames";
import Select from "react-select";
import sectors from "../Careers/Sectors";
import skills from "../KingstonConnect/Skills";
import experience from "../KingstonConnect/Experience";

class EditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: undefined,
      new_data: undefined,
      coupon_type: undefined
    };
  }

  componentDidMount = () => {
    this.setState({
      data: this.props.data,
      new_data: this.props.data
    });
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.data !== prevProps.data) {
      this.setState({
        data: this.props.data,
        new_data: this.props.data
      });
    }
  };

  componentWillUnmount = () => {
    this.setState({
      data: undefined,
      new_data: undefined
    });
  };

  Cancel = () => {
    this.setState(
      {
        new_data: this.state.data
      },
      () => this.props.handleClose()
    );
  };

  SaveAndClose = () => {
    this.props
      .updateOrAdd(this.state.new_data, this.props.type)
      // .then(() => this.props.updateTable());

    this.setState(
      {
        data: this.state.new_data
      },
      () => this.props.handleClose()
    );
  };

  changeValue = (item, val) => {
    this.setState({
      new_data: { ...this.state.new_data, [item]: val },
    });
  };


  render() {
    const showHideClassName = this.props.show
      ? styles.modalDisplayBlock
      : styles.modalDisplayNone;
    if (this.state.data === undefined) {
      return <div />;
    } else {
      return (
        <div className={showHideClassName}>
          <section className={styles.modalMain}>
            <h4>{"Edit/Add " + this.props.type}</h4>
            <div className={styles.EditBox}>
              {Object.entries(this.state.new_data).map((item, key) => {
                // DO NOT DISPLAY OR ALLOW EDITING OF ID
                if (item[0] === "_id") {
                  return <div key={key}/>;
                }
                // HANDLE BOOLEANS WITH CHECKBOX
                else if (typeof item[1] === "boolean") {
                  return (
                    <div className={styles.editRow} key={item[0]}>
                      <p>{item[0]}</p>
                      <label>
                        <input
                          className={styles.InputCheckboxField}
                          type="checkbox"
                          value={this.state.new_data[item[0]]}
                          checked={this.state.new_data[item[0]]}
                          onChange={() =>
                            this.changeValue(
                              item[0],
                              !this.state.new_data[item[0]]
                            )
                          }
                        />
                        <span />
                      </label>
                    </div>
                  );
                }
                // HANDLE PASSWORD
                else if (item[0] === "password") {
                  return (
                    <div className={styles.editRow} key={item[0]}>
                      <p>{item[0]}</p>
                      <input
                        className={"form-control"}
                        type="password"
                        name={item[0]}
                        value={item[1]}
                        onChange={e =>
                          this.changeValue(item[0], e.target.value)
                        }
                      />
                    </div>
                  );
                }
                // HANDLE NUMBER TYPE
                else if (typeof item[1] === "number") {
                  return (
                    <div className={styles.editRow} key={item[0]}>
                      <p>{item[0]}</p>
                      <input
                        className={"form-control"}
                        type="number"
                        name={item[0]}
                        value={item[1]}
                        onChange={e =>
                          this.changeValue(item[0], e.target.value)
                        }
                      />
                    </div>
                  );
                }
                // HANDLE POSSIBLE SET TYPES
                else if (item[0] === 'coupon_type') {
                  return (
                    <div key={item[0]}>
                      <Select
                        placeholder={item[1] ? item[1]: undefined}
                        options={[{value: 'night', label: 'night'},{value: 'sleep', label: 'sleep'},{value: 'golf', label: 'golf'},{value: 'date', label: 'date'}, {value: 'movie', label: 'movie'},{value: 'islands', label: 'islands'}]}
                        onChange={e => this.changeValue(item[0], e.value)}
                      />
                    </div>
                  )
                }
                // HANDLE IF SECTORS
                else if (item[0] === 'sectors') {
                  return (
                    <div key={item[0]}>
                      <p>{item[0]}</p>
                      <Select
                        onChange={e =>
                          this.changeValue(item[0], e)
                        }
                        value={item[1]}
                        options={sectors.slice(1)}
                        isMulti={true}
                        id="sectors"
                        isSearchable />
                    </div>
                  )
                }
                // HANDLE IF SKILLS
                else if (item[0] === 'skills') {
                  return (
                    <div key={item[0]}>
                      <p>{item[0]}</p>
                      <Select
                        onChange={e =>
                          this.changeValue(item[0], e)
                        }
                        value={item[1]}
                        options={skills.slice(1)}
                        isMulti={true}
                        id="skills"
                        isSearchable />
                    </div>
                  )
                }
                else if (item[0] === 'experience') {
                  return (
                    <div key={item[0]}>
                      <p>{item[0]}</p>
                      <Select
                        onChange={e =>
                          this.changeValue(item[0], e)
                        }
                        value={item[1]}
                        options={experience.slice(1)}
                        isMulti={false}
                        id="experience"
                        isSearchable />
                    </div>
                  )
                }
                // EVERYTHING ELSE DISPLAY AS STRING
                else {
                  return (
                    <div className={styles.editRow} key={item[0]}>
                      <p>{item[0]}</p>
                      <input
                        className={"form-control"}
                        type="text"
                        name={item[0]}
                        value={item[1]}
                        onChange={e =>
                          this.changeValue(item[0], e.target.value)
                        }
                      />
                    </div>
                  );
                }
              })}
            </div>
            <button
              className={classnames("btn btn-primary pink z-depth-0", styles.modalButtons)}
              onClick={this.SaveAndClose}
            >
              Save Changes
            </button>
            <button
              className={classnames("btn btn-primary pink z-depth-0", styles.modalButtons)}
              onClick={this.Cancel}
            >
              Cancel
            </button>
          </section>
        </div>
      );
    }
  }
}

export default EditModal;



// WEBPACK FOOTER //
// ./src/components/pages/Admin/EditModal.js